/**
 * Persist redirect/returnPath in sessionStorage and clean the URL so the address bar
 * shows only /login or /register. Used so "return to previous page" still works
 * without exposing query params in the URL.
 */
const AUTH_REDIRECT_KEY = 'auth_redirect';
const AUTH_RETURN_PATH_KEY = 'auth_returnPath';

const getDefaultRedirect = () =>
  process.env.REACT_APP_MAIN_APP_URL || 'http://localhost:3000';
const getDefaultReturnPath = () => '/';

export const getStoredRedirect = () =>
  typeof window !== 'undefined' ? sessionStorage.getItem(AUTH_REDIRECT_KEY) : null;
export const getStoredReturnPath = () =>
  typeof window !== 'undefined' ? sessionStorage.getItem(AUTH_RETURN_PATH_KEY) : null;

export function persistRedirectFromUrl(searchParams, cleanPath) {
  if (typeof window === 'undefined') return;
  const redirect = searchParams.get('redirect');
  const returnPath = searchParams.get('returnPath');
  if (redirect != null || returnPath != null) {
    sessionStorage.setItem(AUTH_REDIRECT_KEY, redirect || getDefaultRedirect());
    sessionStorage.setItem(AUTH_RETURN_PATH_KEY, returnPath || getDefaultReturnPath());
    window.history.replaceState(null, '', cleanPath);
  }
}

export function getRedirectUrl(searchParams) {
  return (
    searchParams.get('redirect') ||
    getStoredRedirect() ||
    getDefaultRedirect()
  );
}

export function getReturnPath(searchParams) {
  return (
    searchParams.get('returnPath') ||
    getStoredReturnPath() ||
    getDefaultReturnPath()
  );
}
